
import styled from 'styled-components'

import PageTopTitle from "../../components/shared/PageTopTitle"
import { useDispatch, useSelector } from "react-redux"
import { useEffect, useState } from "react"
import Button from '../../components/shared/button/Btn'
import { showModal } from '../../features/modal/modalSlice'
import AdminEngellenenAraclarContainer from '../../components/adminContainers/AdminEngellenenAraclarContainer'
import InputText from '../../components/shared/input/new/InputText'
import InputSelect from '../../components/shared/input/new/InputSelect'
import { handleActiveSelect } from '../../features/layout/layoutSlice'
import { getBlockedUsersAdmin } from '../../features/admin3/admin3Slice'
import Pagination from '../../components/shared/Pagination'
import InputNumberNew from '../../components/shared/input/new/InputNumberNew'
import InputSelectAdminBlockedCompany from '../../components/shared/input/special/InputSelectAdminBlockedCompany'
import { getAdminCompanyLoadFilter } from '../../features/loadList/loadListSlice'

const Container = styled.div`

width: 100%;

    .wrapper{
        display: flex;
        flex-direction: column;
        width: 100%;

        .content{
          width: calc(100% - 60px);
            gap: 60px;
            margin: 30px;

            .top-container{
              width: 100%;
              display: flex;
              justify-content: space-between;
              margin: 10px 0;


                .input-container{
                  width: auto;
                  display: flex;
                  align-items: center;
                  gap: 20px;
                }

                .btn-container{
                  display: flex;
                }
              }

              .titles {
                width: 100%;
                display: grid;
                grid-template-columns:  0.4fr 0.4fr 1fr 1fr;
                gap: 15px;
                padding-inline: 10px;
                font-size: var(--font-size-sm);
                font-weight: var(--font-weight-lg);
                text-align: center;
                color: ${({ theme }) => theme.mainTextColor};
                margin-top: 20px;
              }
            }
        }

        .pagination-container{
            gap: 60px;
            margin: 0 30px;
            margin-top: 20px;
            height: 200px;
        }
`
const titles = ["Durum", "Telefon Numarası", "Liste", "Kamyoon Sonuç"]

const reviewedData = [
  {
    id: 1,
    text: "İncelendi",
    value: true
  },
  {
    id: 2,
    text: "İncelenmedi",
    value: false
  }
]

const KamyoonEngellenenAraclar = () => {
  const {adminBlockedUsers, blockedUsersCount} = useSelector((state) => state.admin3)
  const dispatch = useDispatch()
  const storage = JSON.parse(localStorage.getItem("isRemember")) ? localStorage : sessionStorage;
  const rld = JSON.parse(storage.getItem("rld"))
  const { loadListCompanyList  } = useSelector((state) => state.loadList);

  const [isReviewed, setIsReviewed] = useState({text: "", value: ""})
  const [savedByCompanyId, setSavedByCompanyId] = useState(null)
  const [filterData, setFilterData] = useState({
    userName: "",
    nationalId: "",
    plateNumber: "",
    savedByCompanyId: ""
  });
  const [page, setPage] = useState(1)
  const itemsPerPage = 20;

  const totalPages = Math.ceil(blockedUsersCount / itemsPerPage);

  useEffect(() => {
    if(rld === "db7bb061-0f64-4eae-9c4f-678a7359fd01"){
        dispatch(getAdminCompanyLoadFilter())
    }
  },[])

  useEffect(() => {
    dispatch(getBlockedUsersAdmin({page: page, phoneNumber: filterData.phoneNumber, fullNameTitle: filterData.userName, nationalId: filterData.nationalId, plate: filterData.plateNumber, savedByCompanyId: savedByCompanyId?.id, isReviewed: isReviewed?.value}))
  }, [page, filterData, savedByCompanyId, isReviewed])

  const handleFilterData = (e) => {
    setFilterData((prev) => ({...prev, [e.target.name]: e.target.value}));
  }

  const handleClear = () => {
    setFilterData({
      userName: "",
      nationalId: "",
      plateNumber: "",
      phoneNumber: ""
    })
    setSavedByCompanyId(null)
    setIsReviewed({text: "", value: ""})
  }
  return (
    <Container onClick={() => dispatch(handleActiveSelect(null))}>
    <div className="wrapper">
        <PageTopTitle title={"Engellen Araçlar"} position="sticky"/>
        <div className="content">
          <div className="top-container">
            <div className="input-container">
              <InputText data={filterData?.userName} setData={(e) => handleFilterData(e)} name={"userName"} labelText='Ad Soyad' inputWidth={"180px"} />
              <InputText data={filterData?.plateNumber} setData={(e) => handleFilterData(e)} name={"plateNumber"} labelText='Plaka' inputWidth={"180px"} />
              <InputNumberNew max={11} data={filterData?.nationalId} setData={(e) => handleFilterData(e)} name={"nationalId"} labelText='TC No' inputWidth={"180px"} />
              <InputNumberNew max={10} data={filterData?.phoneNumber} setData={(e) => handleFilterData(e)} name={"phoneNumber"} labelText='Telefon' inputWidth={"180px"} />
              <InputSelectAdminBlockedCompany data={savedByCompanyId?.companyName || ""} setData={setSavedByCompanyId} initialOptions={loadListCompanyList} labelText={"Kaydeden Firma"} inputWidth={"180px"} name={"savedByCompanyId"} />
              <InputSelect data={isReviewed?.text || ""} setData={setIsReviewed} labelText={"Liste"} inputWidth={"180px"} initialOptions={reviewedData} name={"isReviewed"} />
              <Button type='button' color={"#E85546"} background={"transparent"} handleClick={handleClear} padding='0 20px' width='auto'>Temizle</Button>

            </div>
            <div className="btn-container">
              <Button type='button' color={"#E85546"} background={"transparent"} handleClick={()=>dispatch(showModal("adminKaraListeEkle"))} padding='0 20px' width='auto'>Ekle</Button>
            </div>
          </div>

          <div className="titles">
            {titles.map((item) => (
              <p>{item}</p>
            ))}
          </div>

          {adminBlockedUsers?.map((item) => (
            <AdminEngellenenAraclarContainer data={item} />
          ))}
            
        </div>
        <div className="pagination-container">
          {(adminBlockedUsers || adminBlockedUsers?.length > 0) && (
            <Pagination
              totalPages={totalPages}
              handleClick={setPage}
              currentPage={page}
            />
          )}
        </div>
    </div>
</Container>
  )
}

export default KamyoonEngellenenAraclar